import { render, staticRenderFns } from "./PromtModal.vue?vue&type=template&id=6d05be35&"
import script from "./PromtModal.vue?vue&type=script&lang=js&"
export * from "./PromtModal.vue?vue&type=script&lang=js&"
import style0 from "./PromtModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports